// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import "flowbite"
import { settings } from "./settings"
import "./instrument"
import { setupKeyboard } from "./keyboard"

import mixpanel from "mixpanel-browser"

mixpanel.init(settings.MIXPANEL_TOKEN, { debug: true, track_pageview: false, persistence: "localStorage" })
setupKeyboard()
